import birthday from "../../assets/playground/birthday.png";
import weather from "../../assets/playground/weather.png"
import tictactoe from "../../assets/playground/tictactoe.png"
import Skinstore from "../../assets/projects/Skinstore.png"

export const projectsData = [
  {
    id: 1,
    projectName: "Birthday Timer",
    liveLink: "https://clinquant-tanuki-64d41e.netlify.app/",
    hasLink: true,
    img: birthday,
  },
  {
    id: 2,
    projectName: "Weather-App",
    liveLink: "https://what-weather.vercel.app/",
    hasLink: true,
    img: weather,
  },
  {
    id: 3,
    projectName: "Tic - Tac - Toe",
    hasLink: true,
    liveLink: "https://relaxed-gingersnap-ff29ef.netlify.app",
    img: tictactoe,
  },
  {
    id: 4,
    projectName: "SkinStore - Clone",
    hasLink: true,
    liveLink: "https://lighthearted-melba-894d29.netlify.app",
    img: Skinstore,
  }
];
